import { createSelector } from 'reselect'

export const getSelectedPackage = createSelector(
  state => state && state.user && state.user.packages && state.user.packages.selectedPackage
    ? state.user.packages.selectedPackage : null,
  selectedPackage => selectedPackage
)
